import { RootState } from '../types'

export const getPaymentTemplates = (state: RootState) => state.paymentTemplates.paymentTemplates
